import { useState } from 'react';
import '../../../styles/theme.css';

export function BluffInput({
  onSubmitBluff,
  disabled = false,
  maxLength = 60,
  placeholder = 'Type a believable fake sound label...'
}) {
  const [bluffText, setBluffText] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (disabled || submitted || !bluffText.trim()) return;

    const textToSubmit = bluffText.trim().substring(0, maxLength);
    setSubmitted(true);
    if (onSubmitBluff) {
      onSubmitBluff({ bluff: textToSubmit });
    }
  };

  const isBtnDisabled = disabled || submitted || !bluffText.trim();
  const remainingChars = maxLength - bluffText.length;

  return (
    <div
      data-testid="bluff-input-card"
      style={{
        padding: '24px 20px',
        background: 'var(--sd-panel, #0D1015)',
        border: '1px solid var(--sd-line, #1A1F25)',
        borderRadius: '16px',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '14px' }}>
        <h3 style={{
          margin: 0,
          fontSize: '1.1rem',
          color: 'var(--sd-ink, #EDEFF2)',
          fontWeight: 700,
          fontFamily: "var(--sd-font-ui, 'Plus Jakarta Sans'), system-ui, sans-serif",
        }}>
          ✍️ Write Your Bluff
        </h3>
        <span style={{
          fontFamily: "var(--sd-font-mono, 'IBM Plex Mono'), monospace",
          fontSize: '11px',
          color: remainingChars < 10 ? 'var(--sd-amber, #E0A458)' : 'var(--sd-dim, #6E7982)',
        }}>
          {remainingChars} left
        </span>
      </div>

      {submitted || disabled ? (
        <div
          data-testid="bluff-submitted-banner"
          style={{
            background: 'rgba(143, 199, 160, 0.12)',
            border: '1px solid rgba(143, 199, 160, 0.35)',
            borderRadius: '12px',
            padding: '16px',
            textAlign: 'center',
            color: 'var(--sd-sage, #8FC7A0)',
            fontWeight: 700,
            fontSize: '0.95rem',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            fontFamily: "var(--sd-font-mono, 'IBM Plex Mono'), monospace",
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span>✓</span> Bluff Submitted! Waiting for other players...
          </div>
          {bluffText && (
            <div style={{
              marginTop: '6px',
              padding: '8px 14px',
              borderRadius: '8px',
              background: 'var(--sd-panel, #0D1015)',
              border: '1px solid var(--sd-line, #1A1F25)',
              color: 'var(--sd-ink, #EDEFF2)',
              fontSize: '13px',
              fontFamily: "var(--sd-font-ui, 'Plus Jakarta Sans'), system-ui, sans-serif",
            }}>
              Your Bluff: <span style={{ color: 'var(--sd-teal, #3ACFCF)', fontWeight: 700 }}>"{bluffText}"</span>
            </div>
          )}
        </div>
      ) : (
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <input
            type="text"
            data-testid="bluff-text-input"
            value={bluffText}
            onChange={(e) => setBluffText(e.target.value.slice(0, maxLength))}
            placeholder={placeholder}
            maxLength={maxLength}
            disabled={disabled || submitted}
            style={{
              width: '100%',
              padding: '14px 16px',
              fontSize: '15px',
              borderRadius: '12px',
              border: '1px solid var(--sd-line-2, #1C2229)',
              background: 'var(--sd-panel-2, #0E1116)',
              color: 'var(--sd-ink, #EDEFF2)',
              boxSizing: 'border-box',
              outline: 'none',
              fontFamily: "var(--sd-font-ui, 'Plus Jakarta Sans'), system-ui, sans-serif",
            }}
          />

          <button
            type="submit"
            data-testid="submit-bluff-btn"
            disabled={isBtnDisabled}
            style={{
              width: '100%',
              height: '54px',
              minHeight: '44px',
              borderRadius: '14px',
              background: isBtnDisabled ? 'var(--sd-panel-2, #0E1116)' : 'var(--sd-teal, #3ACFCF)',
              border: isBtnDisabled ? '1px solid var(--sd-line, #1A1F25)' : '1px solid var(--sd-teal, #3ACFCF)',
              color: isBtnDisabled ? 'var(--sd-dim, #6E7982)' : 'var(--sd-ground, #08090B)',
              fontWeight: 700,
              fontSize: '15px',
              cursor: isBtnDisabled ? 'not-allowed' : 'pointer',
              fontFamily: "var(--sd-font-ui, 'Plus Jakarta Sans'), system-ui, sans-serif",
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              transition: 'all 0.15s ease',
            }}
          >
            <span>🚀</span> Submit Bluff
          </button>
        </form>
      )}
    </div>
  );
}

export default BluffInput;
